import * as React from 'react';
import styled from 'styled-components';
import { Box } from '@origin-digital/layout';
import { Colors, Heading2, Text, BREAK_POINTS } from '@origin-digital/style-guide';
import { BannerProps } from './Banner.types';

export const Wrapper = styled(Box)`
  width: 100%;
  background-size: 40px 40px;
  background-position: 50% 50%;
  background-color: ${Colors.WHITE};
  border-top: solid 1px ${Colors.GREY16};
  border-bottom: solid 1px ${Colors.GREY16};

  padding-left: 42px;
  padding-right: 42px;

  @media only screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 22px 0;
  }

  @media only screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    padding: 32px 0;
  }
`;

const Banner: React.StatelessComponent<BannerProps> = ({
  title,
  subtitle,
  children
}: BannerProps): JSX.Element => {
  return (
    <Box>
      <Wrapper>
        <Box marginTop={8} marginBottom={8} width="100%" justifyContent="center" direction="row">
          <Box marginBottom={4}>
            <Heading2 text={title} align={'center'} fontWeight={'bold'} accessibilityLevel={1} />
          </Box>
          {subtitle ? (
            <Text size={'sm'} align={'center'} color={'grey56'}>
              {subtitle}
            </Text>
          ) : null}
          {children ? (
            <Box
              width="max-content"
              dangerouslySetInlineStyle={{ __style: { margin: '20px auto' } }}
            >
              {children}
            </Box>
          ) : null}
        </Box>
      </Wrapper>
    </Box>
  );
};

export { Banner as default };
